export const Title = ({text}) =>{
    return(
        <p className='title-style'>
            {text}
        </p>
    )
}